import hyperdom from 'hyperdom'

export default function (input, browserCapabilities) {
  if (browserCapabilities.input.placeholder) {
    return input
  } else {
    var placeholder = input.properties.placeholder
    if (placeholder) {
      var value = typeof input.properties.value === 'object' ? input.properties.value && input.properties.value.value : input.properties.value
      input.properties.placeholder = undefined

      return <div class={{'placeholder-polyfill': true, visible: !value}}>
        <span>{placeholder}</span>
        {input}
      </div>
    } else {
      return input
    }
  }
}
